import { Router } from "express";

import { chatController } from "../controllers/chat-controller";
import { authenticate, createRateLimit } from "../middleware/auth-middleware";
import { uploadChatFiles } from "../middleware/upload-middleware";

const router = Router();
const generalRateLimit = createRateLimit.general();

router.use(authenticate);

router.get("/conversations", generalRateLimit, (req, res) =>
  chatController.getChats(req, res),
);

router.post("/conversations", generalRateLimit, (req, res) => {
  const { participantId } = req.body;
  if (participantId && !req.body.studentId && !req.body.teacherId) {
    req.body.participantUserId = participantId;
  }
  void chatController.createOrGetChat(req, res);
});

router.get("/conversations/:id/messages", generalRateLimit, (req, res) => {
  (req.params as { chatId?: string; id: string }).chatId = req.params.id;
  void chatController.getMessages(req, res);
});

router.post(
  "/conversations/:id/messages",
  uploadChatFiles,
  generalRateLimit,
  (req, res) => {
    (req.params as { chatId?: string; id: string }).chatId = req.params.id;
    void chatController.sendMessage(req, res);
  },
);

router.put("/conversations/:id/read", generalRateLimit, (req, res) => {
  (req.params as { chatId?: string; id: string }).chatId = req.params.id;
  void chatController.markAsRead(req, res);
});

router.get("/classes/:classId/group", generalRateLimit, (req, res) =>
  chatController.getClassGroupChat(req, res),
);

router.post("/classes/:classId/group/members", generalRateLimit, (req, res) =>
  chatController.addClassGroupMember(req, res),
);

router.delete(
  "/classes/:classId/group/members/:studentId",
  generalRateLimit,
  (req, res) => chatController.removeClassGroupMember(req, res),
);

export default router;
